import { SettingsSagaWatcher } from './Settings/services/saga';

export const aboutModuleSaga = [SettingsSagaWatcher];
